import { useEffect } from 'react';
import { TENANT_SUSPENDED_EVENT } from '@/lib/tenantSuspension';
import { clearStorageKeepLoginEndpoint, signedOutPath } from '@/lib/loginEndpoint';

// Signs a teacher/student out when their school gets suspended mid-session
// and sends them to their school's login page, which explains the suspension.
// Owners/admins (billing_only) stay signed in — InstitutionDashboard shows
// them the billing-only view instead.
export default function TenantSuspensionGuard() {
  useEffect(() => {
    const onSuspended = (event) => {
      if (event.detail?.billing_only) return;
      // Not signed in (e.g. a refused login) — the login page shows the message inline.
      if (!localStorage.getItem('desky_token')) return;
      const target = signedOutPath();
      clearStorageKeepLoginEndpoint();
      window.location.replace(target);
    };
    window.addEventListener(TENANT_SUSPENDED_EVENT, onSuspended);
    return () => window.removeEventListener(TENANT_SUSPENDED_EVENT, onSuspended);
  }, []);
  return null;
}
